module.exports = __webpack_public_path__ + "static/media/checkbox-not-selected.337b27b9.svg";